export function createItem(_a) {
    var _b = _a.id, id = _b === void 0 ? null : _b, _c = _a.moduleId, moduleId = _c === void 0 ? '' : _c, _d = _a.name, name = _d === void 0 ? '' : _d, _e = _a.data, data = _e === void 0 ? null : _e;
    return {
        id: id,
        moduleId: moduleId,
        name: name,
        data: data,
    };
}
